import { env } from '@env';

export const config = {
  API_BASE_URL: env.REACT_APP_API_BASE_URL,
  DEFAULT_PAGE: env.REACT_APP_DEFAULT_PAGE,
  TEST_ENV: env.REACT_APP_TEST_ENV === 'true',
  LANG: env.REACT_APP_LANG || 'ES',
  VERSION_CHECK_INTERVAL: Number(env.REACT_APP_VERSION_CHECK_INTERVAL || 30 * 1000),
  SUPPORT_APP_ID: env.REACT_APP_SUPPORT_APP_ID,
  TRACKING_ENABLED: env.REACT_APP_TRACKING_ENABLED === 'true',
  TRACKING_API_URL: env.REACT_APP_TRACKING_API_URL,
  TRACKING_API_KEY: env.REACT_APP_TRACKING_API_KEY,
  PUSH_API_KEY: env.REACT_APP_PUSH_API_KEY,
  OPTIONS_FETCH_LIMIT: Number(env.REACT_APP_OPTIONS_FETCH_LIMIT || 100),
  SECURE: env.REACT_APP_SECURE === 'true',
  AUTO_FILL_SECRET: env.REACT_APP_AUTO_FILL_SECRET,
};
